__turbopack_context__.v({
  "active": "product-module-scss-module__W1477G__active",
  "anotherPrice": "product-module-scss-module__W1477G__anotherPrice",
  "color": "product-module-scss-module__W1477G__color",
  "colorPriceWrapper": "product-module-scss-module__W1477G__colorPriceWrapper",
  "colors": "product-module-scss-module__W1477G__colors",
  "discountPrice": "product-module-scss-module__W1477G__discountPrice",
  "image": "product-module-scss-module__W1477G__image",
  "label": "product-module-scss-module__W1477G__label",
  "labels": "product-module-scss-module__W1477G__labels",
  "plus": "product-module-scss-module__W1477G__plus",
  "price": "product-module-scss-module__W1477G__price",
  "prices": "product-module-scss-module__W1477G__prices",
  "product": "product-module-scss-module__W1477G__product",
  "productGraphics": "product-module-scss-module__W1477G__productGraphics",
  "productInfo": "product-module-scss-module__W1477G__productInfo",
  "title": "product-module-scss-module__W1477G__title",
  "variants": "product-module-scss-module__W1477G__variants",
  "variantsWindow": "product-module-scss-module__W1477G__variantsWindow",
  "visible": "product-module-scss-module__W1477G__visible",
  "window": "product-module-scss-module__W1477G__window",
  "wishlistBtn": "product-module-scss-module__W1477G__wishlistBtn",
});
